import React, {useState} from 'react';
import {useParams} from 'react-router-dom';
import {useQuery} from 'react-query';
import {getResourceById, getResources} from '../../../../services/resourceSvc';
import ResourceForm from "./components/ResourceForm";
import ResourceList from "./components/ResourceList";

export const ResourceCreatePage = () => {
  const {lessonId} = useParams();
  const [selectedResource, setSelectedResource] = useState<number | null>(null);

  const {data: resourceById} = useQuery(['getResourceById', selectedResource], () => getResourceById(selectedResource!), {
    enabled: !!selectedResource,
  });

  const {
    data: resourceData,
    isLoading: resourceIsLoading,
    refetch: refetchResources,
  } = useQuery('getResources', () => getResources(lessonId!));

  const handleEditClick = (resource) => {
    setSelectedResource(resource.id);
  };

  return (
      <div>
        <ResourceForm
            selectedResource={selectedResource}
            setSelectedResource={setSelectedResource}
            resourceById={resourceById}
            lessonId={lessonId!}
            refetchResources={refetchResources}
        />
        <ResourceList
            resourceData={resourceData}
            resourceIsLoading={resourceIsLoading}
            refetchResources={refetchResources}
            handleEditClick={handleEditClick}
        />
      </div>
  );
};